import React from 'react';
import { Field } from 'formik';
import { Form as BulmaForm } from '@codeparva/ui-components-library';
import { FormFieldsTypes } from './FormFieldsTypes';
import { getAsterisk } from './helper/GetAstrisk';

export const RadioButtonField = ({
  name,
  label,
  values,
  required,
}: FormFieldsTypes.IRadioButtonField) => {
  const { Radio } = BulmaForm;
  return (
    <>
      {label && (
        <label htmlFor={name}>
          {label}
          {required === true && getAsterisk()}
        </label>
      )}
      {values.map((value: string) => (
        <Field type="radio" name={name} id={name} placeholder={''} as={Radio}>
          {value}
        </Field>
      ))}
    </>
  );
};
